import { AccountModel, TBrand, TBrandEnrich, TEnrichPerson, UserModel } from "cakemail-ui-components-v2"
import { TButtonRef } from "cakemail-ui-components-v2/dist/esm/components/button/types"
import { Dispatch, JSX, SetStateAction } from "react"

export type TOnboarding = {
    setUser: Dispatch<SetStateAction<UserModel | undefined>>
    onOnboardingCompleted: (onboardingData: TOnboardingCompleted) => Promise<void>
}

export type TOnboardingCompletedCallback = (onboardingData: TOnboardingCompleted) => void

export enum EOnboardingStep {
    user = "user",
    industry = "industry",
    company = "company",
    brand = "brand",
    foundMatch = "foundMatch",
    manageAccountsConfirmation = "manageAccountsConfirmation",
    completed = "completed"
}

export type TStepMap = Record<string, { id: number, title: string, desc: string | any, name: string, component: JSX.Element, enrichTitle?: string, enrichDesc?: string }>

export type TOnboardingCompleted = {
    userForm: UserModel
    industryForm: TOnboardingIndustryForm
    companyForm: AccountModel
    brandForm: Partial<TBrand>,
    isAgency: boolean
}

export type TOnboardingIndustryForm = {
    industry?: string
    sector?: string
    teamSize?: string
}

export type TOnboardingContext = {
    userForm: UserModel
    setUserForm: Dispatch<SetStateAction<UserModel>>
    industryForm: TOnboardingIndustryForm
    setIndustryForm: Dispatch<SetStateAction<TOnboardingIndustryForm>>
    companyForm: AccountModel
    setCompanyForm: Dispatch<SetStateAction<AccountModel>>
    brandForm: Partial<TBrand>
    setBrandForm: Dispatch<SetStateAction<Partial<TBrand>>>
    onOnboardingCompleted: TOnboardingCompletedCallback
    step: EOnboardingStep
    setStep: Dispatch<SetStateAction<EOnboardingStep>>
    enrichedPerson?: TEnrichPerson | null
    setEnrichedPerson: Dispatch<SetStateAction<TEnrichPerson | null | undefined>>
    enrichedBrand?: TBrandEnrich | null
    setEnrichedBrand: Dispatch<SetStateAction<TBrandEnrich | null | undefined>>
    handleNext: (btnRef?: TButtonRef) => void,
    isAgency: boolean,
    setIsAgency: Dispatch<SetStateAction<boolean>>
}